import { makeAutoObservable } from "mobx"
import { PossibleAnswerList } from "../lists/PossibleAnswerList"
import { PossibleAnswerProps } from "./PossibleAnswer"

type QuestionType = "single_choice" | "multi_choice" | "text_field" | "text_area" | "file_upload"
export interface QuestionProps {
  id?: number
  type: QuestionType
  label: string
  description?: string
  questionnaireId: number
  possibleAnswers?: PossibleAnswerProps[]
  file?: string
  optional: boolean
  url?: string
  givenAnswers?: []
}

export class Question {
  id?: number
  type?: QuestionType
  label: string
  description?: string
  tripId: number
  questionnaireId: number
  possibleAnswers?: PossibleAnswerList
  file?: string
  optional: boolean
  url?: string
  givenAnswers?: []

  constructor(props: QuestionProps) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.id = props.id
    this.type = props.type
    this.label = props.label ? props.label : undefined
    this.description = props.description
    this.questionnaireId = props.questionnaireId
    this.possibleAnswers = props.possibleAnswers && new PossibleAnswerList(props.possibleAnswers)
    this.file = props.file
    this.optional = props.optional
    this.url = props.url
    this.givenAnswers = props.givenAnswers
  }

  get hasPossibleAnswers() {
    return this.type === "single_choice" || this.type === "multi_choice"
  }

  get hasGivenAnswers() {
    return this.givenAnswers && this.givenAnswers.length > 0
  }

  setSingleChoice() {
    this.type = "single_choice"
    this.possibleAnswers.maybePushDefaultPossibleAnswers()
  }

  setMultiChoice() {
    this.type = "multi_choice"
    this.possibleAnswers.maybePushDefaultPossibleAnswers()
  }

  setTextField() {
    this.type = "text_field"
    this.possibleAnswers.clearPossibleAnswers()
    this.possibleAnswers.deleteAll()
  }

  setTextArea() {
    this.type = "text_area"
    this.possibleAnswers.clearPossibleAnswers()
    this.possibleAnswers.deleteAll()
  }

  setFileUpload() {
    this.type = "file_upload"
    this.possibleAnswers.clearPossibleAnswers()
    this.possibleAnswers.deleteAll()
  }
}
